export default {
  administrators: []
}



// WEBPACK FOOTER //
// ./src/components/admin/store/state.js